<template>
    <div class="pin-board-item" :id="'listing-' + id">
        <div class="pin-board-item-card" :class="{traded: isTraded}">
            <div v-if="isGrail" class="bg-grail p-2 text-light rounded-top text-center" title="This pin is in your Grail list!">
                <strong><i class="fa-regular fa-crown"></i> GRAIL ALERT</strong>
            </div>
            <div v-else-if="isIso" class="bg-iso p-2 text-light rounded-top text-center" title="This pin is in your ISO list!">
                <strong><i class="fa-regular fa-magnifying-glass-plus"></i> ISO ALERT</strong>
            </div>
            <div class="card pin-data-root" :class="{ pending: isPendingOffer }">
                <h5 class="rarity-container position-absolute"><span class="rarity badge" :class="rarity">{{ rarity }}</span></h5>
                <div v-show="!isListing || isMystery" class="offers-count">{{ animatedOffers }} offers</div>
                <div class="card-image d-flex align-items-center">
                    <span v-if="isTraded || isMine || (isListing && !isMystery)">
                        <picture>
                            <source :srcset="'https://pinandpop.s3.amazonaws.com/images/pinails/' + thumb + '.webp'" type="image/webp">
                            <source :srcset="'https://pinandpop.s3.amazonaws.com/images/pinails/' + thumb + '.jpg'" type="image/jpeg">
                            <img class="card-img-top" :src="'https://pinandpop.s3.amazonaws.com/images/pinails/' + thumb + '.jpg'" :alt="name">
                        </picture></span>
                    <trade-link v-else :id="id">
                        <picture>
                            <source :srcset="'https://pinandpop.s3.amazonaws.com/images/pinails/' + thumb + '.webp'" type="image/webp">
                            <source :srcset="'https://pinandpop.s3.amazonaws.com/images/pinails/' + thumb + '.jpg'" type="image/jpeg">
                            <img class="card-img-top" :src="'https://pinandpop.s3.amazonaws.com/images/pinails/' + thumb + '.jpg'" :alt="name">
                        </picture></trade-link>
                </div>
                <div class="card-body">
                    <h5 class="card-title">
                        <span v-if="isTraded || isMine || (isListing && !isMystery)" class="text-muted">{{ title }}</span>
                        <trade-link v-else :id="id">
                            {{ title }}
                        </trade-link>
                    </h5>
                    <div v-if="isTraded" class="text-center">
                        <button type="button" class="btn btn-sm btn-danger disabled"
                                title="This pin has already been traded.">
                            <i class="fa-regular fa-right-left"> </i> TRADED
                        </button>
                    </div>
                    <div v-else-if="isMine" class="text-center">
                        <div class="alert alert-dark text-center py-0 mb-0">YOUR PIN</div>
                        <a v-show="!isListing || isMystery" class="small" :href="'/my/listings/' + id + '/offers'" target="_blank">view offers</a>
                    </div>
                    <div v-else v-show="isPendingOffer" class="text-center">
                        <trade-link :id="id"><button type="button" class="btn btn-sm btn-danger"
                                                     title="You have a pending trade offer on this pin. Good Luck!">
                            <i class="fa-regular fa-right-left"> </i> PENDING TRADE
                        </button></trade-link>
                    </div>
                </div>
                <div v-if="!isMine && !isListing" class="text-end">
                    <a @click.prevent="toggleWatch" href="#"><span class="rounded-pill bg-light p-1"><i class="fa-star" :class="[isWatched ? 'fa-solid text-grail' : 'fa-regular text-muted']"></i></span></a>
                </div>
            </div>
            <div v-if="isOwned" class="bg-own p-1 text-light text-center" :class="{'rounded-bottom': !isGrail && !isIso}">
                <small>You OWN this</small>
            </div>
            <div v-if="isGrail" class="bg-grail p-1 text-light rounded-bottom text-center">
                <small>In your Grail list</small>
            </div>
            <div v-else-if="isIso" class="bg-iso p-1 text-light rounded-bottom text-center">
                <small>In your ISO list</small>
            </div>
        </div>
    </div>
</template>

<script>
import TradeLink from "./TradeLink.vue";
import { gsap } from "gsap";

export default {
    name: 'PinBoardItem',
    components: {
        TradeLink
    },
    props: {
        id: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        thumb: {
            type: String,
            required: true
        },
        rarity: {
            type: String,
            required: false
        },
        isTraded: {
            type: Boolean,
            required: false
        },
        isGrail: {
            type: Boolean,
            required: false
        },
        isIso: {
            type: Boolean,
            required: false
        },
        isOwned: {
            type: Boolean,
            required: false
        },
        isPendingOffer: {
            type: Boolean,
            required: false
        },
        offersCount: {
            type: Number,
            required: false
        },
        isMine: {
            type: Boolean,
            required: false
        },
        isListing: {
            type: Boolean,
            default: false
        },
        isMystery: {
            type: Boolean,
            default: false
        },
        isWatching: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            tweenedOffers: 0,
            isWatched: this.isWatching
        }
    },
    computed: {
        animatedOffers: function() {
            return this.tweenedOffers.toFixed(0);
        }
    },
    mounted() {
        this.tweenedOffers = this.offersCount;
    },
    methods: {
        toggleWatch: function() {
            if (this.isWatched) {
                axios.delete('/api/my/watchlist/' + this.id).then(response => {
                    this.isWatched = false;
                }).catch(error => {
                    this.handleError(error);
                });
            } else {
                axios.post('/api/my/watchlist', {'listing': this.id}).then(response => {
                    this.isWatched = true;
                }).catch(error => {
                    this.handleError(error);
                });
            }
        },

        handleError(error) {
            if (error.response.status === 401) {
                window.location.href = '/login?intended='+window.location.pathname;
            } else if (error.response.status === 419) {
                window.location.reload();
            }
        }
    },
    watch: {
        offersCount: function(newValue) {
            document.querySelector('#listing-' + this.id).querySelector('.offers-count').classList.add('active');
            gsap.to(this.$data, { duration: 10, tweenedOffers: newValue });
        }
    }
}
</script>
